export default {
  // Create/edit diet-plan builder and the overview sufficiency trend card.
  DIET_PLAN_V2: "coach-diet-plan-v2",
};
